module.exports = __webpack_public_path__ + "img/back-copy.f3ed20e1.svg";